<template>
    <div>
       
    </div>
</template>

<script>
import axios from 'axios'
    export default {
        name: 'ItemsImport',
        props: ['item','igvGlobal','diez','dieciocho','unoDieciocho','unoUno','ceroDieciocho','ceroUno','action',],
        data: () => {
            return {
                preitem: {},
                items: []
            }
        },
        mounted() {
            this.initPreItem()
        },
        watch: {
            'action.i': function () {
                if(this.action.i){
                    this.completeItem()
                }   
            },
            'action.reset': function () {
                if(this.action.reset){
                    this.items = []
                }   
            }
        },
        methods: {
            initPreItem: function () {
                this.preitem = {
                    tipoAfectacionIgv: 0,
                    codigoTributo: '',
                    idProducto: '-',
                    codigoProductoSunat: '',
                    unidadMedidaCantidad: '',
                    cantidad: '',
                    descripcion: '',
                    valorUnitario: '',
                    tipoPrecioVentaUnitario: '',
                    descuento: '',
                    porcentajeDescuento:0,
                    baseAfectacionIgv: '',
                    valorUnitarioVista: '',
                    valorVenta: '',
                    valorVentaVista: '',
                    porcentajeImpuesto: '',
                    montoAfectacionIgv: '',
                    montoTotalImpuestosItem: '',
                    precioVentaUnitario: '',
                    observacion:'',
                    subopcionSeleccionada:'',
                    adicional: {
                        numeroPlacaVehiculo: '',
                        indicardorDsct:'',
                        dsctSoles:'',
                        dsctPorcentaje:'',
                        precioVentaUni:'',
                        precioTotalIGV:0.0
                    },
                }
            },
            convertExceltoJson: function () {
                // Funcion para la carga masiva de items
            },
            completeItem: function () {
                if(this.item){
                    this.preitem.cantidad = parseFloat(this.item.cantidad)
                    this.preitem.codigoProducto = this.item.codigo
                    this.preitem.unidadMedidaCantidad = this.item.unidadMedida
                    this.preitem.descripcion = this.item.descripcion
                    this.preitem.observacion = this.item.observacion
                    this.preitem.tipoPrecioVentaUnitario = '01'
                    this.preitem.descuento = 0
                    this.preitem.idProducto = this.item.idProducto
                    this.preitem.valorVenta = this.item.valorVenta
                    this.preitem.precioVentaUnitario = parseFloat(this.item.precioUnitario)
                    if(this.item.tipoAfectacionIgv=='01'){
                        this.preitem.tipoAfectacionIgv = '10'
                        this.preitem.codigoTributo = '1000'
                        this.preitem.porcentajeImpuesto = (this.$store.state.igv == 18 ? 18 : 10.5); //18
                        this.preitem.valorUnitario = this.item.precioUnitario / (this.$store.state.igv == 18 ? 1.18 : 1.105); //1.18
                        this.preitem.valorUnitarioVista =  this.item.precioUnitario / (this.$store.state.igv == 18 ? 1.18 : 1.105); //1.18
                        this.preitem.baseAfectacionIgv = parseFloat(this.preitem.valorUnitario*this.preitem.cantidad) 
                        this.preitem.montoAfectacionIgv = this.preitem.baseAfectacionIgv * (this.$store.state.igv == 18 ? 0.18 : 0.105); //0.18
                    }
                    else if(this.item.tipoAfectacionIgv=='02'){
                        this.preitem.tipoAfectacionIgv = '30'
                        this.preitem.codigoTributo = '9998'
                        this.preitem.porcentajeImpuesto = parseInt(0)
                        this.preitem.valorUnitario = this.item.precioUnitario
                        this.preitem.valorUnitarioVista = this.item.precioUnitario
                        this.preitem.baseAfectacionIgv = parseFloat(this.preitem.valorUnitario*this.preitem.cantidad)  
                        this.preitem.montoAfectacionIgv = parseFloat(0.00) 
                    }else if(this.item.tipoAfectacionIgv=='03'){
                        this.preitem.tipoAfectacionIgv = '20'
                        this.preitem.codigoTributo = '9997'
                        this.preitem.porcentajeImpuesto = parseInt(0)
                        this.preitem.valorUnitario = this.item.precioUnitario
                        this.preitem.valorUnitarioVista = this.item.precioUnitario
                        this.item.precioUnitario = this.item.precioUnitario
                        this.preitem.baseAfectacionIgv = parseFloat(this.preitem.valorUnitario*this.preitem.cantidad)  
                        this.preitem.montoAfectacionIgv = parseFloat(0.00) 
                    }


                    this.preitem.montoTotalImpuestosItem = parseFloat(this.preitem.montoAfectacionIgv)
                    this.preitem.valorVenta = this.preitem.baseAfectacionIgv
                    if(this.item.boleta == 'boleta'){
                        this.preitem.valorVentaVista = this.preitem.valorUnitario * this.preitem.cantidad
                    }else{
                        this.preitem.valorVentaVista = parseFloat(this.preitem.precioVentaUnitario) * parseFloat(this.preitem.cantidad)
                    }                  
                    if(this.item.placa && this.item.placa.length>3){
                        this.preitem.adicional.numeroPlacaVehiculo = this.item.placa
                    }else{
                        // delete this.preitem.adicional
                    }
                    this.preitem.adicional.precioVentaUni = parseFloat(this.item.precioUnitario)

                    this.preitem.subopcionSeleccionada = this.item.subopcionSeleccionada
                    this.items.unshift(this.preitem)
                    this.initPreItem()
                    this.getItems(this.items)
                }
            },
            getItems: function (data) {
                this.$emit("totalitems", data);
            }
        }  
    }
</script>

<style>

</style>